import { useState } from 'react';
import { CollapsibleContainer, CollapsibleText, DividerLine } from './styles';

interface CollapsibleToggleProps {
  defaultExpanded?: boolean;
  toggleText: { expanded: string; collapsed: string };
  children: JSX.Element[];
}

export const CollapsibleToggle = ({
  defaultExpanded = false,
  toggleText,
  children
}: CollapsibleToggleProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleToggle = () => {
    setIsExpanded((isExpanded) => !isExpanded);
  };

  return (
    <>
      <CollapsibleContainer onClick={handleToggle}>
        <DividerLine />
        <CollapsibleText>{isExpanded ? toggleText.expanded : toggleText.collapsed}</CollapsibleText>
        <DividerLine />
      </CollapsibleContainer>
      {isExpanded && children}
    </>
  );
};
